import axios from "axios";
import { serverUrl } from "../nestserver";

const auth = () => ({
  headers: {
    Authorization: `Bearer ${window.localStorage.getItem("jwt-token")}`,
  },
});

/** The backend wraps every success in { result: ... }. */
const unwrap = (res) => res?.data?.result;

/** Errors come back as { error: { errors: [...] } }, but not consistently. */
export function smsWalletError(err, fallback = "Something went wrong") {
  return (
    err?.response?.data?.error?.errors?.[0] ||
    err?.response?.data?.error?.errors ||
    err?.response?.data?.message ||
    fallback
  );
}

// ── wallet (prepaid billing — ₹0.20 per fee reminder/confirmation SMS) ──

export async function fetchSmsWalletBalance() {
  const res = await axios.get(`${serverUrl}/sms-wallet/balance`, auth());
  return unwrap(res) || { balance_paise: 0 };
}

export async function fetchSmsWalletStatement(params = {}) {
  const res = await axios.get(`${serverUrl}/sms-wallet/statement`, {
    ...auth(),
    params,
  });
  return unwrap(res) || { data: [], total: 0, page: 1, limit: 20 };
}

/**
 * Reuses the existing payment-gateway Razorpay order/verify routes with
 * `purpose: 'SMS_WALLET_RECHARGE'` rather than a new endpoint — same
 * approach as the WhatsApp wallet's createWalletRechargeOrder. IMPORTANT:
 * unlike every other call in this file, `payment-gateway.controller.ts`'s
 * order/verify routes return the service result directly — not wrapped in
 * `{ result: ... }` — so these two read `res.data`, not `unwrap(res)`.
 */
export async function createSmsWalletRechargeOrder(amountPaise, schoolId) {
  const res = await axios.post(
    `${serverUrl}/payment-gateway/order`,
    {
      amount: amountPaise,
      currency: "INR",
      schoolId,
      purpose: "SMS_WALLET_RECHARGE",
      notes: { info: "SMS wallet recharge" },
    },
    auth(),
  );
  return res.data;
}

export async function verifySmsWalletRechargePayment(payload) {
  const res = await axios.post(
    `${serverUrl}/payment-gateway/verify`,
    payload,
    auth(),
  );
  return res.data;
}
